import { render, staticRenderFns } from "./MoleculeEditionAcademyInvitationsModalCreate.vue?vue&type=template&id=2082612d&"
import script from "./MoleculeEditionAcademyInvitationsModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyInvitationsModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports